import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import ReportModal from './ReportModal';

const SSO_URL = process.env.REACT_APP_SSO_URL || 'https://auth.yuuu.es';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [showReportModal, setShowReportModal] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-links">
            <a
              href="https://yuuu.es"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              {t('footer.poweredBy', 'Powered and Developed by Yuuu')}
            </a>
            <a
              href="https://liberapay.com/TheWNetwork"
              target="_blank"
              rel="noopener noreferrer"
              className="donation-button"
            >
              <i className="fas fa-donate"></i> {t('footer.donate', 'Donate')}
            </a>
            <a
              href={`${SSO_URL}/legal/cookies?lang=${i18n.language}&from=${window.location.origin}`}
              target="_blank" rel="noopener noreferrer"
              className="footer-link policy-link"
            >
              {t('footer.cookiePolicy')}
            </a>
            <a
              href={`${SSO_URL}/legal/privacy?lang=${i18n.language}&from=${window.location.origin}`}
              target="_blank" rel="noopener noreferrer"
              className="footer-link policy-link"
            >
              {t('footer.privacyPolicy')}
            </a>
            <a
              href={`${SSO_URL}/legal/terms?lang=${i18n.language}&from=${window.location.origin}`}
              target="_blank" rel="noopener noreferrer"
              className="footer-link policy-link"
            >
              {t('footer.termsConditions')}
            </a>
            <button
              onClick={() => setShowReportModal(true)}
              className="footer-link policy-link report-link"
            >
              <i className="fas fa-flag"></i> {t('footer.reportIssue', 'Report an issue')}
            </button>
          </div>
        </div>
      </div>
      {showReportModal && (
        <ReportModal onClose={() => setShowReportModal(false)} />
      )}
    </footer>
  );
};

export default Footer;
